var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SlidePage1',{attrs:{"disabled":"","readonly":""}}),_vm._v(" "),_c('SlidePage2',{attrs:{"disabled":"","readonly":""}}),_vm._v(" "),_c('SlidePage3',{attrs:{"disabled":"","readonly":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }